import { Box, Grid2, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import CustomInput from '../../theme/style-components/CustomInput';
import CustomButton from '../../theme/style-components/CustomButton';
import { useAddCertificationMutation, useEditCertificationMutation } from '../../store/certification/CertificationSlice';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import AssignCertificateCard from './AssignCertificateCard';
import AssignCertificateModal from './AssignCertificateModal';
import { useSelector } from 'react-redux';
import { selectCurrentUserObject } from '../../store/auth/authSlice';

const AddEditCertificate = ({ isEditCertificate, selectedCertificate }) => {

  const [addCertification] = useAddCertificationMutation();
  const [editCertification] = useEditCertificationMutation();
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const user = useSelector(selectCurrentUserObject);

  useEffect(() => {
    if (isEditCertificate && selectedCertificate) {
      formik.setValues({
        name: selectedCertificate?.name || "",
        description: selectedCertificate?.description || '',
        link: selectedCertificate?.link || ""

      });
    }
  }, [isEditCertificate, selectedCertificate]);

  const handleAssignBtn=()=>{
    setIsModalOpen(true)
  }

  const formik = useFormik({
    initialValues: {
      name: isEditCertificate ? selectedCertificate?.name : '',
      description: isEditCertificate ? selectedCertificate?.description : '',
      link: isEditCertificate ? selectedCertificate?.link : '',
    },
    onSubmit: async (values) => {

      try {
        if (isEditCertificate) {
          const certificationData = {
            ...values,
            certificate_id: selectedCertificate?.id,
          };
          // Editing an existing certification
          const result = await editCertification(certificationData).unwrap();
          console.log(result, 'res');
          toast.success('Certificate updated successfully');
          navigate('/certifications');
        } else {
          const newCertificate = {
            ...values,
            org_id: user?.company,
          };
          // Adding a new certification
          const result = await addCertification(newCertificate).unwrap();
          console.log(result, 'res');
          toast.success('Certificate added successfully');
          navigate('/certifications');
        }
      } catch (error) {
        toast.error('Something went wrong!');
      }
    },
  });

  return (
    <>
    <form>
      <Grid2 contanier spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Box>
            <Typography variant="h6" sx={{ fontSize: "15px" }}>
              Name
            </Typography>
            <CustomInput
              id="name"
              name="name"
              placeholder={"Enter name"}
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              sx={{ maxWidth: 50 }}
            />
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Box>
            <Typography variant="h6" sx={{ fontSize: "15px" }}>
              description
            </Typography>
            <CustomInput
              id="description"
              name="description"
              placeholder={"Enter Description"}
              value={formik.values.description}
              onChange={formik.handleChange}
              error={formik.touched.description && Boolean(formik.errors.description)}
              helperText={formik.touched.description && formik.errors.description}
              sx={{ maxWidth: 50 }}
            />
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Box>
            <Typography variant="h6" sx={{ fontSize: "15px" }}>
              Link
            </Typography>
            <CustomInput
              id="link"
              name="link"
              placeholder={"Enter Link"}
              value={formik.values.link}
              onChange={formik.handleChange}
              error={formik.touched.link && Boolean(formik.errors.link)}
              helperText={formik.touched.link && formik.errors.link}
              sx={{ maxWidth: 50 }}
            />
          </Box>
        </Grid2>
          <Grid2 size={{ xs: 12 }} sx={{ mt: 2 }}>
            <Box display={"flex"} justifyContent={"end"} gap={1.5}>
              {isEditCertificate &&
                <CustomButton
                  color="primary"
                  type="button"
                  buttonName="Assign"
                  onClick={handleAssignBtn}
                />
              }
              <CustomButton
                color="primary"
                type="button"
                buttonName="Cancel"
                onClick={() => navigate("/certifications")}
              />
              <CustomButton
                color="primary"
                type="button"
                buttonName="Submit"
                onClick={() => formik.handleSubmit()}
              />
            </Box>
          </Grid2>
      </Grid2>
    </form>
    {isEditCertificate && 
      <AssignCertificateCard selectedCertificate={selectedCertificate} />
    }
    {isEditCertificate && isModalOpen &&
      <AssignCertificateModal isModalOpen={isModalOpen} handleClose={()=> setIsModalOpen(false)} selectedCertificateId={selectedCertificate?.id} />
    }
    </>
  )
}

export default AddEditCertificate
